var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-dot"}),_c('h3',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.title))])]),_c('block-content',{staticStyle:{"padding":"24px 16px","margin-top":"14px"},attrs:{"secondary":""}},[_c('pre',{staticClass:"pre"},[_vm._v(_vm._s(_vm.content))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }